import { isYieldLine } from './yieldLine';
import { isNutritionLine } from './nutritionLine';

/**
 * The single "this line is not a food" gate for the read path.
 *
 * Recipe ingredient lists in the catalog carry more than ingredients: the
 * recipe's yield ("Pour 4 personnes") and, on three recipes, the entire
 * nutrition panel. Both rendered as checkable, buyable ingredient rows (#594).
 *
 * Every predicate behind this gate must be anchored enough that a real food can
 * never match it — an ingredient wrongly deleted is discovered at the store,
 * while a stray row is merely ugly. Add new ones here so the ingredients list
 * and the step chips can never drift apart on what counts as food.
 */
export function isNonFoodIngredientLine(text: string): boolean {
  return isYieldLine(text) || isNutritionLine(text);
}
